import { getInsightsHabits } from '@griply/utils';
import { useHabits } from 'features/tasks';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useUser } from 'shared/hooks/use-user';

export const useInsightsHabits = () => {
  const today = useToday();
  const user = useUser();
  const habits = useHabits();

  return useMemo(
    () =>
      getInsightsHabits({
        habits,
        today,
        insightsSettings: user?.settings?.insights,
        habitSorting: user?.settings?.habitSorting ?? [],
      }),
    [habits, today, user?.settings?.habitSorting, user?.settings?.insights],
  );
};
